import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AflacChoice from "../icons/aflac-choice-large.png";
import User from "../../../../icons/user.svg";
import PinLocation from "../../../../icons/pin-location.svg";
import Calendar from "../../../../icons/calendar1.svg";
import AflacChoiceText from "../icons/aflac-choice-text.png";
import Download from '../icons/download.svg';
import { Button, CircularProgress, SvgIcon, makeStyles } from '@material-ui/core';
import Table from 'react-bootstrap/Table';
import Age from '../../../Helpers/Dates/Age';
import GetStateListForAflac from '../Helpers/StateListForAflac';
import { getBrochure } from "../Helpers/Brochures";
import { ARIZONA, CONNECTICUT, IDAHO, NEWMEXICO, VIRGIN_ISLANDS, WEST_VIRGINIA, ARKANSAS, DISTRICT_OF_COLUMBIA, IOWA, OHIO, VERMONT } from '../../../Helpers/Constants/States';

export default function SplashPage(props) {

    const [individualPlanPremium, setIndividualPlanPremium] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const age = Age(props.basicInfo.birthdate);
    const state = props.basicInfo.state;
    const isHSA = props.basicInfo.hsaAccount;
    const states = GetStateListForAflac().find(a => a.value === state).label;
    const coverageAmountOptions = props.coverageAmountOptions();

    const useStyles = makeStyles((theme) => ({
        quoteCardColor: {
            color: theme.palette.primary.main,
        },
        dot: {
            height: '12px',
            width: '12px',
            borderRadius: ' 50%',
            background: theme.palette.primary.main,
            margin: '0 auto',
        }
    }));
    const amount = props.basicInfo.state === CONNECTICUT && coverageAmountOptions.length > 0 && coverageAmountOptions[0].value === "500" ? coverageAmountOptions.length >= 1 ? coverageAmountOptions[1].value : "0" : coverageAmountOptions[0].value;
    const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;
    useEffect(() => {
        fetch(`${covrServicesUrl}/api/Aflac/GetAflacChoiceQuotes?state=${state}&age=${age}&hospitalAmount=${amount}&healthSavingsAccount=${isHSA}`, {
            method: 'GET',
        })
            .then((response) => response.json())
            .then((data) => {
                if (data) {
                    setIsLoading(false);
                    setIndividualPlanPremium(Number(data.individualPremium.premium).toFixed(2));
                }
            }).catch(() => {
                setIsLoading(false);
            });
    }, []);

    const handleBrochure = (isHSA, state) => {
        const brochure = getBrochure(isHSA, state);
        props.downloadPDF(brochure.option, brochure.filename);
    };

    const classes = useStyles();
    const getStateCTBenefitName = (state === ARIZONA || state === CONNECTICUT || state === IDAHO || state === NEWMEXICO || state === VIRGIN_ISLANDS || state === WEST_VIRGINIA);
    const getStateBenefitName = (state === ARIZONA || state === IDAHO || state === NEWMEXICO || state === VIRGIN_ISLANDS || state === WEST_VIRGINIA);
    const benifitLabelAllowedStates = [ARKANSAS, DISTRICT_OF_COLUMBIA, IOWA, OHIO, VERMONT];

    return (
        <div className="container-md container splash-container">
            <div className="information-block">
                <div className="left">
                    <h4 className="mt-4">{props.headerText}</h4>
                    <div className="top-description">
                        <img src={AflacChoiceText} alt='aflac' />
                        <p>Aflac pays cash benefits directly to you, unless otherwise assigned, during periods of hospitalization or care resulting from sickness or injury.</p>
                    </div>
                    <div className="plan-info">
                        <div className="primary-users">
                            <h6>Primary Applicant</h6>
                            <div className="user-details-wrapper">
                                <div className="user-details">
                                    <SvgIcon
                                        color="primary" component={User} />
                                    <div className="detail">
                                        <strong>Gender: </strong>
                                        <span>{props.basicInfo.gender === "M" ? 'Male' : "Female"}</span>
                                    </div>
                                </div>
                                <div className="user-details">
                                    <SvgIcon
                                        color="primary" component={PinLocation} />
                                    <div className="detail">
                                        <strong><span className="d-none d-lg-inline">Residence</span> <span className="d-inline">State: </span></strong>
                                        <span>{states}</span>
                                    </div>
                                </div>
                                <div className="user-details">
                                    <SvgIcon
                                        color="primary" component={Calendar} />
                                    <div className="detail">
                                        <strong>Age: </strong>
                                        <span>{age}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="plan-details">
                            <h6>Plan starts at</h6>
                            <div className="price">
                                {isLoading ?
                                    <CircularProgress />
                                    : <React.Fragment>
                                        <sup className={classes.quoteCardColor}>$</sup>
                                        <p className={classes.quoteCardColor}>{individualPlanPremium}</p>
                                        <span className={classes.quoteCardColor}>/mo</span>
                                    </React.Fragment>}

                            </div>{!isLoading && <Button variant="contained" color="primary" className="continue-btn" onClick={props.onNext}>
                                <span>NEXT</span>
                            </Button>}
                        </div>
                    </div>
                </div>
                <div className="right">
                    <img src={AflacChoice} alt="" />
                </div>
            </div>
            <div className="table-wrapper">
                <div className="wrapper-header">
                    <h1><span className={classes.quoteCardColor}>Aflac </span><strong className={classes.quoteCardColor}>Choice </strong>{isHSA ? 'for those with an HSA' : 'for those without an HSA'}</h1>
                    <ul>
                        {isHSA &&
                            <React.Fragment>
                                <li><p>{state === 'PA' ? 'Hospital Admission' : getStateBenefitName ? 'Hospital Confinement' : 'Hospital Stay'}: <span className={classes.quoteCardColor}>$500 to $2,000 per year</span></p></li>
                                {state === 'MD' && <li><p> Second Hospitalization Opinion: <span className={classes.quoteCardColor}> $25/confinement</span></p></li>}
                                <li><p>{getStateCTBenefitName ? 'Daily Hospital Confinement' : 'Daily Hospital Stay'}: <span className={classes.quoteCardColor}>$100/Day</span></p></li>
                                {state === 'MD' && <li><p>Outpatient Visit: <span className={classes.quoteCardColor}>$100/visit</span></p></li>}
                                <li><p>{getStateCTBenefitName ? 'Hospital Intensive Care Unit Confinement' : 'ICU Confinement'}: <span className={classes.quoteCardColor}>$50/Day</span></p></li>
                                {benifitLabelAllowedStates.includes(state) && <li><p>{state === "DC" || state === "IA" ? "Wellbaby Hospitalization:" : "Newborn Hospital Care:"}<span className={classes.quoteCardColor}>$25/Day</span></p></li>}
                                {state === "MD" && <li><p>Wellbaby Hospitalization: <span className={classes.quoteCardColor}>$100/day</span></p></li>}
                                {(state === "IA" || state === "UT") && <li><p>Childbirth: <span className={classes.quoteCardColor}> $250/pregnancy</span></p></li>}
                                {state === "OH" && <li><p>Childbirth: <span className={classes.quoteCardColor}> $125 to $500 per pregnancy</span></p></li>}
                            </React.Fragment>
                        }
                    </ul>
                    {!isHSA && !isLoading &&
                        <Button variant="contained" color="primary" onClick={props.onNext} disabled={!individualPlanPremium}>NEXT</Button>
                    }
                </div>

                {!isHSA &&
                    <Table striped responsive>
                        <thead>
                            <tr>
                                <th><p>Plan Benefits</p></th>
                                {<th className="large-text"><span className={classes.quoteCardColor}>Aflac <strong className={classes.quoteCardColor}>Choice</strong></span></th>}
                                {state !== 'CT' && <th><span className={classes.quoteCardColor}>Aflac <strong className={classes.quoteCardColor}>Choice</strong> & the optional Extended Benefits Rider</span></th>}
                                {state !== 'CT' && <th><span className={classes.quoteCardColor}>Aflac <strong className={classes.quoteCardColor}>Choice</strong> & the optional Hospital Stay and Surgical Care Rider</span></th>}
                                {state === 'CT' && <th><span className={classes.quoteCardColor}>Aflac <strong className={classes.quoteCardColor}>Choice</strong> & the Optional Hospital Stay Rider</span></th>}
                                {state !== 'CT' && <th className="large-text"><span className={classes.quoteCardColor}>Aflac <strong className={classes.quoteCardColor}>Choice</strong> Plus Both Optional Riders</span></th>}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                <tr className="less-highlighted">
                                    <td>{state === 'PA' ? 'Hospital Admission' : getStateBenefitName ? 'Hospital Confinement' : 'Hospital Stay'}</td>
                                    <td><div className={classes.dot} /></td>
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                    {state === 'CT' && <td><div className={classes.dot} /></td>}
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                </tr>
                            }
                            {(state === 'MD') &&
                                <tr className="highlighted">
                                    <td>Second Hospitalization Opinion</td>
                                    <td><div className={classes.dot} /></td>
                                    <td><div className={classes.dot} /></td>
                                    <td><div className={classes.dot} /></td>
                                    <td><div className={classes.dot} /></td>
                                </tr>
                            }
                            {(props.mentalIllnessFacilityStates.includes(state) || state === 'CT') &&
                                <tr className='highlighted'>
                                    <td>Mental Illness Facility Confinement</td>
                                    <td><div className={classes.dot} /></td>
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                    {state === 'CT' && <td><div className={classes.dot} /></td>}
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                </tr>
                            }
                            {
                                <tr className={(props.mentalIllnessFacilityStates.includes(state) || state === 'CT' || state === 'MD') ? 'less-highlighted' : 'highlighted'}>
                                    <td>{getStateBenefitName ? 'Rehabilitation Facility' : 'Rehab Facility Visit'}</td>
                                    <td><div className={classes.dot} /></td>
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                    {state === 'CT' && <td><div className={classes.dot} /></td>}
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                </tr>
                            }
                            {
                                <tr className={(props.mentalIllnessFacilityStates.includes(state) || state === 'CT' || state === 'MD') ? 'highlighted' : 'less-highlighted'}>
                                    <td>{getStateBenefitName ? 'Hospital Emergency Room' : 'Emergency Room Visit'}</td>
                                    <td><div className={classes.dot} /></td>
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                    {state === 'CT' && <td><div className={classes.dot} /></td>}
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                </tr>
                            }
                            {
                                <tr className={(props.mentalIllnessFacilityStates.includes(state) || state === 'CT' || state === 'MD') ? 'less-highlighted' : 'highlighted'}>
                                    <td>{getStateBenefitName ? 'Hospital Short-Stay' : 'Outpatient Visit'}</td>
                                    <td><div className={classes.dot} /></td>
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                    {state === 'CT' && <td><div className={classes.dot} /></td>}
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                </tr>
                            }
                            {benifitLabelAllowedStates.includes(state) &&
                                <tr className={(props.mentalIllnessFacilityStates.includes(state)) ? 'highlighted' : 'less-highlighted'}>
                                    <td>{state === "DC" || state === "IA" ? 'Wellbaby Hospitalization' : 'Newborn Hospital Care'}</td>
                                    <td><div className={classes.dot} /></td>
                                    <td><div className={classes.dot} /></td>
                                    <td><div className={classes.dot} /></td>
                                    <td><div className={classes.dot} /></td>
                                </tr>
                            }
                            {(state === 'UT' || state === 'OH' || state === "IA") &&
                                <tr className={state === 'UT' || state === 'OH' || state === "IA" ? 'less-highlighted' : 'highlighted'}>
                                    <td>Childbirth</td>
                                    <td><div className={classes.dot} /></td>
                                    <td><div className={classes.dot} /></td>
                                    <td><div className={classes.dot} /></td>
                                    <td><div className={classes.dot} /></td>
                                </tr>
                            }
                            {(state === 'IN') &&
                                <tr className="highlighted">
                                    <td>Telemedicine Services</td>
                                    <td><div className={classes.dot} /></td>
                                    <td><div className={classes.dot} /></td>
                                    <td><div className={classes.dot} /></td>
                                    <td><div className={classes.dot} /></td>
                                </tr>
                            }
                            {(state !== 'CT') &&
                                <tr>
                                    <td>{getStateBenefitName ? 'Physician Visit' : 'Doctor Visit'}</td>
                                    <td />
                                    <td><div className={classes.dot} /></td>
                                    <td />
                                    <td><div className={classes.dot} /></td>
                                </tr>
                            }
                            {(state !== 'CT') &&
                                <tr>
                                    <td>{getStateBenefitName ? 'Laboratory Test and X-Ray' : 'Lab Test'}</td>
                                    <td />
                                    <td><div className={classes.dot} /></td>
                                    <td />        
                                    <td><div className={classes.dot} /></td>
                                </tr>
                            }
                            {(state !== 'CT') &&
                                <tr>
                                    <td>{getStateBenefitName ? 'Medical Diagnostic and Imaging Exams' : 'Diagnostic Exam'}</td>
                                    <td />
                                    <td><div className={classes.dot} /></td>
                                    <td />
                                    <td><div className={classes.dot} /></td>
                                </tr>
                            }
                            {
                                <tr>
                                    <td>{state === 'CT' ? 'Initial Assistance' : 'Ground Ambulance'}</td>
                                    <td />
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                    {state !== 'CT' && <td />}
                                    {state === 'CT' && <td><div className={classes.dot} /></td>}
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                </tr>
                            }
                            {
                                <tr>
                                    <td>{state === 'CT' ? 'Hospital Intensive Care Unit Confinement' : 'Air Ambulance'}</td>
                                    <td />
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                    {state !== 'CT' && <td />}
                                    {state === 'CT' && <td><div className={classes.dot} /></td>}
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                </tr>
                            }
                            {(state !== 'NY') &&
                                <tr>
                                    <td>{state === 'CT' ? 'Daily Hospital Confinement' : getStateBenefitName ? 'Initial Assistance' : 'Hospital Admission'}</td>
                                    <td />
                                    {state !== 'CT' && <td />}
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                    {state === 'CT' && <td><div className={classes.dot} /></td>}
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                </tr>
                            }
                            {(state !== 'CT') &&
                                <tr>
                                    <td>Surgery</td>
                                    <td />
                                    <td />
                                    <td><div className={classes.dot} /></td>
                                    <td><div className={classes.dot} /></td>
                                </tr>
                            }
                            {state !== 'CT' &&
                                <tr>
                                    <td>Invasive Diagnostic Exam</td>
                                    <td />
                                    <td />
                                    <td><div className={classes.dot} /></td>
                                    <td><div className={classes.dot} /></td>
                                </tr>
                            }
                            {state === 'CT' &&
                                <tr>
                                    <td>Daily Mental Illness Facility Confinement</td>
                                    <td />
                                    {state !== 'CT' && <td />}
                                    {state !== 'CT' && <td />}
                                    <td><div className={classes.dot} /></td>
                                    {state !== 'CT' && <td />}                            
                                </tr>
                            }
                            {
                                <tr>
                                    <td>{state === 'CT' ? 'Ground Ambulance' : getStateBenefitName ? 'Hospital Intensive Care Unit Confinement' : 'ICU Confinement'}</td>
                                    <td />
                                    {state !== 'CT' && <td />}
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                    {state === 'CT' && <td><div className={classes.dot} /></td>}
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                </tr>
                            }
                            {
                                <tr>
                                    <td>{state === 'CT' ? 'Air Ambulance' : getStateBenefitName ? 'Daily Hospital Confinement' : 'Daily Hospital Stay'}</td>
                                    <td />
                                    {state !== 'CT' && <td />}
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                    {state === 'CT' && <td><div className={classes.dot} /></td>}
                                    {state !== 'CT' && <td><div className={classes.dot} /></td>}
                                </tr>
                            }
                            {(props.mentalIllnessFacilityStates.includes(state)) &&
                                <tr>
                                    <td>Daily Mental Illness Facility Confinement</td>
                                    <td />
                                    <td />
                                    <td><div className={classes.dot} /></td>
                                    <td><div className={classes.dot} /></td>                        
                                </tr>
                            }
                            {state !== 'CT' &&
                                <tr>
                                    <td>Second Surgical Opinion</td>
                                    <td />
                                    <td />
                                    <td><div className={classes.dot} /></td>
                                    <td><div className={classes.dot} /></td>
                                </tr>
                            }
                        </tbody>
                    </Table>
                }
            </div>
            <div className="splash-bottom-block">
                <div className="inner">
                    <Button variant="contained" className="download-btn" onClick={() => handleBrochure(isHSA, state)}>
                        <SvgIcon color="primary" component={Download} className={'header-icon'} />
                        <div className='text'>
                            <span className={classes.quoteCardColor}>Aflac Choice Brochure</span><br/>
                            <span className='font-weight-normal'>Aflac Choice Brochure and Summary of Coverage (Outline of Coverage)</span>
                        </div>
                        
                    </Button>
                    <div className="backnext-btn">
                        <Button variant="contained" color="primary" onClick={props.onBack}>BACK</Button>
                        <Button variant="contained" color="primary" onClick={props.onNext} disabled={!individualPlanPremium}>NEXT</Button>
                    </div>
                </div>
            </div>
        </div >
    );
}

SplashPage.propTypes = {
    onNext: PropTypes.func,
    onBack: PropTypes.func,
    basicInfo: PropTypes.object,
    fullFormState: PropTypes.object,
    coverageAmountOptions: PropTypes.func,
    downloadPDF: PropTypes.func,
    headerText: PropTypes.string
};

SplashPage.DefaultFormState = (prefill = false) => {
    return {

    };
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Aflac/steps/SplashPage.js